import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-recruiter-router',
    template: `
    <app-candidates></app-candidates>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RecruiterRouterComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }
}